import Modal from "../../UI/Modal";
import Button from "../../UI/Button";
import InputSelect, { SelectOption } from "../../UI/Inputs/InputSelect";
import style from "../../../pages/Compare/index.module.css";
import { useForm } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { VehicleNames } from "../../../utils/GeneralTypes";
import axios from "axios";
import { getAttributesFor, getBrandsFor, getModelsFor } from "../../../utils/fetcher";
import { moduleToSelectOptions } from "../../Vehicles/FindVehicleFilter/utils";
import LoadingSkeleton from "../../UI/LoadingSkeleton";
import { useTranslation } from "../../../hooks/useTranslation";

const AddVehicleToCompare = ({ setVehicles, setIsAddModalActive, vehicleNames, vehicleState }: ComponentPropsType) => {
  const { locale } = useTranslation();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: {
      brands: SelectOption[];
      brandsDependants: any[];
      models: SelectOption[];
      classes: SelectOption[];
    };
  }>({
    isFetching: true,
    data: {
      brands: [],
      brandsDependants: [],
      models: [],
      classes: [],
    },
  });

  const { register, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      brand: "no_option",
      model: "no_option",
      class: "no_option",
    },
  });

  const watchedInputs = watch();

  useEffect(() => {
    let data: any = {
      brands: [],
      brandsDependants: [],
      models: [],
      classes: [],
    };
    (async () => {
      await axios
        .all([
          getBrandsFor(vehicleState, vehicleNames.single),
          getModelsFor(vehicleNames.single),
          getAttributesFor(vehicleNames.single),
        ])
        .then((res) => {
          const brands = moduleToSelectOptions(res[0].data.brands, [["name", ""], "id", "logo"], ["model"]);
          data.brands = brands.options;
          data.brandsDependants = brands.dependantConditions;
          data.models = moduleToSelectOptions(res[1].data.models, [["name", "year"], "id", "image"], null, [
            "brand",
          ]).options;
        })
        .catch((error) => {});
      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, [vehicleState, vehicleNames]);

  const [submitState, setSubmitState] = useState<{
    isSubmitting: boolean;
    error: string;
    success: boolean;
  }>({
    isSubmitting: false,
    error: "",
    success: false,
  });

  // useEffect(() => {}, [watchedInputs.model]);

  const onAddCompareHandler = useCallback(() => {
    setSubmitState({
      isSubmitting: true,
      error: "",
      success: false,
    });
    // updateCompare(vehicleNames.plural, isRemoveModalActive.toString());
    // setVehicles((currentState) => ({
    //   ...currentState,
    //   data: {
    //     ...currentState.data,
    //     vehicles: currentState.data.vehicles.filter(
    //       (el) => el.id.toString() !== isRemoveModalActive.toString()
    //     ),
    //   },
    // }));
    setIsAddModalActive(false);
    setVehicles((current: any) => ({
      ...current,
      isFetching: true,
    }));
  }, [setIsAddModalActive, setVehicles]);

  return (
    <Modal onClose={() => setIsAddModalActive(false)}>
      <div className={style.modal}>
        <p className={style.modal_title}>
          {locale("add_another")} {locale(vehicleNames.single)}
        </p>
        {submitState.error && <p className={style.modal_error}>{submitState.error}</p>}
        {componentData.isFetching ? (
          <div style={{ width: "100%", marginTop: "30px" }}>
            <LoadingSkeleton count={5} />
          </div>
        ) : (
          <form style={{ width: "100%" }} onSubmit={handleSubmit(onAddCompareHandler)}>
            <div className={style.modal_inputs}>
              <InputSelect
                props={{
                  ...register("brand"),
                  value: watchedInputs.brand,
                }}
                selectOptions={componentData.data.brands}
                label={locale("brand")}
                setValue={setValue}
                watchedInputs={watchedInputs}
                dependantConditions={componentData.data.brandsDependants}
              />
              <InputSelect
                props={{ ...register("model"), value: watchedInputs.model }}
                selectOptions={componentData.data.models}
                label={locale("model")}
                watchedInputs={watchedInputs}
              />
            </div>
            <div className={style.modal_ctas}>
              <Button styleType="primary" buttonType="submit">
                {locale("add_to_compare")}
              </Button>
            </div>
          </form>
        )}
      </div>
    </Modal>
  );
};

export default AddVehicleToCompare;

type ComponentPropsType = {
  setIsAddModalActive: CallableFunction;
  setVehicles: CallableFunction;
  vehicleNames: VehicleNames;
  vehicleState: "new" | "used" | "imported";
};
